import { render, staticRenderFns } from "./AnonymousDuty.vue?vue&type=template&id=56a7da9a"
import script from "./AnonymousDuty.vue?vue&type=script&lang=ts"
export * from "./AnonymousDuty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports